import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy} from '@angular/core';




@Component({
    selector: 'project-list',
    standalone: false,
    templateUrl: './project-list.component.html'

})

export class ProjectListComponent implements OnInit, AfterViewInit, OnDestroy {

    constructor(    ) {

    }
    ngOnInit(): void {}
    ngOnDestroy(): void {}
    ngAfterViewInit() {}
}